// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bf13d7bf","477":"29d4ca56","583":"1cc73580","599":"ef2c106f","729":"6f7b66ac","897":"eb0312d0","939":"21411b72"}[chunkId] + ".chunk.js";
};